// Lightweight client-side reading profile (no accounts) — powers "Препоръчани за теб".
const KEY = "pd_reading";
const MAX = 30;

export function recordRead(article) {
  if (!article?.slug) return;
  try {
    const list = JSON.parse(localStorage.getItem(KEY) || "[]");
    const filtered = list.filter((x) => x.slug !== article.slug);
    filtered.unshift({
      slug: article.slug,
      category: article.category,
      ts: Date.now(),
    });
    localStorage.setItem(KEY, JSON.stringify(filtered.slice(0, MAX)));
  } catch (e) {
    /* ignore storage errors */
  }
}

export function getReadingProfile() {
  try {
    const list = JSON.parse(localStorage.getItem(KEY) || "[]");
    const counts = {};
    for (const x of list) {
      if (x.category) counts[x.category] = (counts[x.category] || 0) + 1;
    }
    const categories = Object.entries(counts)
      .sort((a, b) => b[1] - a[1])
      .map(([c]) => c);
    const slugs = list.map((x) => x.slug);
    return { categories, slugs, hasHistory: list.length > 0 };
  } catch (e) {
    return { categories: [], slugs: [], hasHistory: false };
  }
}
